import * as t from "io-ts";
import { createStopDocumentTypes } from "dora-contracts";

const { stopDocumentT, stopDocumentsByStopIdT } = createStopDocumentTypes({
  dateTime: t.string,
});

export const documentT = stopDocumentT;
export const documentsT = t.array(documentT);
export const documentsByStopIdT = stopDocumentsByStopIdT;

export type Document = t.TypeOf<typeof documentT>;
